<template>
  <div>
    <iModal title="新增配置项" v-model="showModal" class-name="common-ad-add" width="900px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="120" @submit.native.prevent>
            <FormItem label="名称：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="banner：" required>
              <div class="my-upload">
                <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index">
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height: 100px;" />
                    <div class="my-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="2048" :headers="formHeaders"
                  :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag" :action="uploadUrl" style="display: inline-block;"
                  v-show="uploadList && uploadList.length < 1">
                  <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                    <div style="font-size:25px">
                      +
                      <p style="font-size:14px">上传图片</p>
                    </div>
                  </div>
                </Upload>
                <iModal title="图片查看" cancel-text v-model="visible">
                  <div style="text-align: center;">
                    <img :src="imgName" v-if="visible" style="max-width: 100%" />
                  </div>
                </iModal>
              </div>
              <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下的jpg或png )</p>
            </FormItem>
            <FormItem label="跳转类别：" prop="skipType">
              <Select v-model="formInline.skipType" style="width:200px">
                <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="小程序appId：" prop="appId" v-show="formInline.skipType === 'wechatUrl'|| formInline.skipType === 'otherWeChatUrl'">
              <Input v-model="formInline.appId" />
            </FormItem>
            <FormItem label="链接地址：" prop="skipContent" v-show="formInline.skipType === 'content'">
              <div ref="editorElement"></div>
            </FormItem>
            <FormItem label="链接地址：" prop="skipContent" v-show="formInline.skipType !== 'content'">
              <Input v-model="formInline.skipContent" />
            </FormItem>
           
            <FormItem label="是否启用：" prop="isEnable">
              <iSwitch v-model="formInline.isEnable" size="large">
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </iSwitch>
            </FormItem>
            <FormItem label="统计链接：" prop="">
              <Input v-model="formInline.linksTotalUrl" />
              <p>统计链接请前往统计管理页面获取，<span style="color: #3190FF;cursor: pointer;" @click="$router.push('/host/index/set/statisticalManage')">去获取</span></p>
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber :max="9999" :min="0" v-model="formInline.showIndex"></InputNumber>
              <p style="font-size:12px;">（数字越小显示中显示越靠前）</p>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import wangeditor from "wangeditor";
import config from '@assets/config.json';

import axios from 'axios';

export default {
  name: "common-banner-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'firstPage'
    },
  },
  data () {
    return {
      loading: false,
      showModal: false,
      formInline: {
        name: "",
        showIndex: 0,
        skipType: 'normalUrl',
        isEnable: true,
        skipContent: '',
        appId: '',
        linksTotalUrl: '',
      },
      ruleInline: {
        // title: [{ required: true, message: '请选择标题', trigger: 'change' }],
      },
      uploadList: [],
      defaultList: [],
      imgName: "",
      visible: false,
      typeList: [
        { value: 'normalUrl', label: '外链' },
        { value: 'wechatUrl', label: '小程序链接' },
        { value: 'content', label: '富文本' },
        { value: 'otherWeChatUrl', label: '跳转其它小程序' },
      ]
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
    })
  },
  mounted () {  
    this.initEditor();
  },
  methods: {
    ...mapActions({
      addWeChatSkipSettle: "hostWeChatSkipSettle/addWeChatSkipSettle",
    }),
    async initEditor () {
      this.editor = new wangeditor(this.$refs.editorElement);
      this.editor.customConfig.zIndex = 1;
      // 赋值
      this.editor.customConfig.onchange = (e) => {
        this.formInline.skipContent = e;
      };

      // 上传图片配置
      const that = this;
      this.editor.customConfig.customUploadImg = function (files, insert) {
        files.forEach((item) => {
          let fd = new FormData();
          fd.append("file", item); // 上传的文件： 键名，键值
          axios
            .post(`${config.api.reqApi}/api/upload/images`, fd)
            .then((data) => {
              if (data.data.successed) {
                insert(data.data.list[0]);
              } else {
                that.$Message.error("上传失败，请重试！");
              }
            })
            .catch((err) => {
              that.$Message.error("上传失败，请重试！");
              console.log(err.response.data);
            });
        });
      };

      this.editor.customConfig.menus = [
        // 菜单配置
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
      ];
      this.editor.create(); // 创建富文本实例  
    },
    // 查看上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    // 文件格式错误
    handleFormatError (file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize (file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload (file) {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    async handleSubmit (name) {
      let form = this.formInline;
      if (this.uploadList.length == 0) {
        this.$Message.warning("请上传图片");
        return;
      }
      let imgList = this.transfromImgList(this.uploadList);
      let req = {
        type: this.type,
        name: form.name,
        pictureUrl: imgList[0],
        skipType: form.skipType,
        skipContent: form.skipContent,
        showIndex: form.showIndex,
        isEnable: form.isEnable,
        otherAppId: form.appId,
        linksTotalUrl: form.linksTotalUrl,
      };
      this.loading = true;
      let bool = await this.addWeChatSkipSettle(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      } else {
        this.cancel();
        this.$emit("finish");
        this.loading = false;
        this.$Message.success("添加成功！");
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    transfromImgList (arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    cancel () {
      this.formInline.link = "";
      this.formInline.showIndex = 0;
      this.uploadList = [];
      this.$refs.upload.fileList = [];
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss">
.common-ad-add {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS styles go here
  .common-ad-add {
    display: block;

    .ivu-modal {
      top: 150px;
    }
  }
}
</style>
